import dummyImage from "@/assets/images/dummy-img.png";
import dummyVector from "@/assets/images/dummy-vector.png";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
interface OpportunityCardProps {
  id: string;
  title: string;
  description: string;
  company: string;
  location: string;
  type: string;
  imageUrl?: string;
  status?: string;
}

const OppurtunityCard = ({
  id,
  title,
  description,
  // company,
  // location,
  // type,
  imageUrl = dummyImage,
  status,
}: OpportunityCardProps) => {
  const getStatusVariant = (status?: string) => {
    if (!status) return "secondary";
    const lowerStatus = status.toLowerCase();
    if (lowerStatus === "open") return "success";
    if (lowerStatus === "closed") return "secondary";
    if (lowerStatus === "published") return "success";
    if (lowerStatus === "draft") return "secondary";
    return "outline";
  };

  return (
    <div className="group rounded-lg border bg-white p-4 transition-shadow duration-200 hover:shadow-md">
      {/* Image Section */}
      <div className="mb-4 h-40 w-full overflow-hidden rounded-md relative">
        <img
          src={imageUrl}
          alt={title}
          className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105"
        />
        {status && (
          <div className="absolute top-2 right-2">
            <Badge variant={getStatusVariant(status)} className="capitalize">
              {status}
            </Badge>
          </div>
        )}
      </div>
      <img src={dummyVector} alt="" />

      {/* Content Section */}
      <div className="space-y-2 mt-4">
        {/* Title */}
        <h3 className="line-clamp-2 text-sm font-outfit leading-4 font-medium text-[#202339]">
          {title}
        </h3>

        {/* Description */}
        <p className="line-clamp-2 text-xs font-outfit leading-4 text-[#7E7E7E]">
          {description}
        </p>
        <div className="mt-3">
          <Link
            to={`/dashboard/opportunities/${id}`}
            className="font-outfit text-xs leading-4 text-[#202339] underline mt-4"
          >
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OppurtunityCard;
